import { apiClient, orgApiPath } from '@/core/api';
import type { Creative, Page } from '@/types/api';
import { listQueryString } from '@/services/pagination';

export interface CreativeCreateBody {
  name: string;
  format_id: string;
  template_id: string;
  render_duration_ms?: number | null;
  assigned_campaign_ids?: number[];
}

import type { CreativeNeoPayload } from '@/types/api';

export interface CreativeUpdateBody {
  name?: string | null;
  render_duration_ms?: number | null;
  elements?: unknown[] | null;
  assigned_campaign_ids?: number[] | null;
  thumbnail_url?: string | null;
  neo?: CreativeNeoPayload | null;
}

export interface ListCreativesParams {
  cursor?: string | null;
  limit?: number;
  campaign_id?: number;
}

export async function listCreatives(params: ListCreativesParams = {}): Promise<Page<Creative>> {
  const { cursor, limit = 50, campaign_id } = params;
  const search = new URLSearchParams(listQueryString({ cursor, limit }));
  if (campaign_id != null) {
    search.set('campaign_id', String(campaign_id));
  }
  return apiClient<Page<Creative>>(orgApiPath(`/creatives?${search.toString()}`));
}

export async function getCreative(id: number): Promise<Creative> {
  return apiClient<Creative>(orgApiPath(`/creatives/${id}`));
}

export async function createCreative(body: CreativeCreateBody): Promise<Creative> {
  return apiClient<Creative>(orgApiPath('/creatives'), {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export async function updateCreative(id: number, body: CreativeUpdateBody): Promise<Creative> {
  return apiClient<Creative>(orgApiPath(`/creatives/${id}`), {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export async function deleteCreative(id: number): Promise<void> {
  return apiClient<void>(orgApiPath(`/creatives/${id}`), {
    method: 'DELETE',
  });
}
